import { useEffect, useState } from 'react'
import { legacyPointChargeMock } from '../../mock/legacyPointCharge'
import './LegacyPointCharge.css'

const digits = (value: string) => value.replace(/\D/g, '')
const money = (value: number) => value.toLocaleString('ko-KR')
const phoneNumber = (value: string) => {
  const raw = digits(value).slice(0, 11)
  if (raw.length <= 3) return raw
  if (raw.length <= 7) return `${raw.slice(0, 3)}-${raw.slice(3)}`
  return `${raw.slice(0, 3)}-${raw.slice(3, 7)}-${raw.slice(7)}`
}

export function LegacyPointCharge() {
  const [amount, setAmount] = useState('')
  const [chargedAmount, setChargedAmount] = useState(0)
  const [phone, setPhone] = useState<string>(legacyPointChargeMock.phone)

  useEffect(() => {
    document.title = 'EDRP 사용 포인트 충전'
  }, [])

  const calculate = () => {
    const value = Number(digits(amount) || 0)
    setAmount(value ? money(value) : '')
    setChargedAmount(Math.floor(value * legacyPointChargeMock.usableRate))
  }

  const pay = (method: 'online' | 'sms') => {
    const value = Number(digits(amount) || 0)
    if (value === 0) {
      window.alert('구매하실 제품을 선택해주세요')
      return
    }

    if (method === 'online') {
      window.alert('온라인결제 Mock 요청을 확인했습니다. 실제 NICEPAY 결제는 실행하지 않았습니다.')
      return
    }

    const confirmed = window.confirm(`SMS 결제링크를 받으시겠습니까?\n(번호가 틀리실 경우 번호를 변경해주세요)\n\n받으실 번호 : ${phone}`)
    if (confirmed) {
      window.alert(`SMS링크결제 Mock 요청을 확인했습니다. ${phone} 번호로 실제 문자를 발송하지 않았습니다.`)
    }
  }

  return <div className="g_content_wrap legacy-p06">
    <div className="g_title">EDRP 사용 포인트 충전</div>
    <form name="payForm" onSubmit={(event) => event.preventDefault()}>
      <table>
        <tbody>
          <tr><th>충전 금액</th><td className="padding_top_10"><input aria-label="충전 금액" id="charge_Amt" className="g_input max_w_150" name="Amt" value={amount} onChange={(event) => setAmount(digits(event.target.value))} onBlur={calculate} /></td></tr>
          <tr><th>충전될 금액</th><td className="padding_top_10"><input aria-label="충전될 금액" id="after_charge_Amt" className="g_input max_w_150" value={chargedAmount ? money(chargedAmount) : '0'} readOnly /></td></tr>
          <tr><th>휴대폰 번호</th><td className="padding_top_10"><input aria-label="휴대폰 번호" id="phone_number" className="g_input max_w_150" value={phone} maxLength={13} onChange={(event) => setPhone(phoneNumber(event.target.value))} /></td></tr>
        </tbody>
      </table>
      <div className="btn_wrap">
        <button className="buy_btn buy_btn1" type="button" onClick={() => pay('online')}>온라인결제</button>&nbsp;
        <button className="buy_btn buy_btn2" type="button" onClick={() => pay('sms')}>SMS링크결제</button>
      </div>
    </form>
  </div>
}
